import { Navigate, Outlet } from 'react-router-dom';
import { useAppSelector } from 'src/hooks';

const ProtectedRoute = () => {
  const { isAuthenticated } = useAppSelector((state) => state.auth);
  return isAuthenticated ? <Outlet /> : <Navigate to='/auth' />;
};

export default ProtectedRoute;
